<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
        <span>{{ modoExcecao ? 'Regra de Exceção' : 'Regra Padrão' }}</span>
        <div class="section-title-actions ms-auto">
            <span class="personalizar-tooltip-wrap"
                [matTooltip]="personalizarTooltip"
                [matTooltipDisabled]="!personalizarBloqueado">
                <button mat-button type="button" class="btn-section"
                    [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0"
                    [disabled]="personalizarBloqueado"
                    (click)="onPersonalizar()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </span>
        </div>
    </div>

    <div class="row g-3">

        <!-- Código -->
        <div class="col-12">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ modoExcecao ? 'Código da exceção' : 'Código' }}</mat-label>
                <mat-select formControlName="cstIpi" (selectionChange)="onCstIpiSelectionChange()">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (c of codigoTributosDoTipoOperacao; track c.codigo) {
                    <mat-option [value]="c.codigo">{{ c.codigo }} – {{ c.descricao }}</mat-option>
                    }
                </mat-select>
                @if (form.get('cstIpi')?.hasError('required') && form.get('cstIpi')?.touched) {
                <mat-error>Código é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Alert Código meta -->
        @if (texto) {
        <div class="col-12">
            <app-alert-card [type]="texto.alertaTipo" [title]="texto.alertaTitulo">
                {{ texto.alertaTexto }}
            </app-alert-card>
        </div>
        }

        <!-- Código de Enquadramento Legal (cEnq) -->
        @if (codigosEnquadramentoIpi.length > 0) {
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Código de Enquadramento</mat-label>
                <mat-select formControlName="codigoEnquadramentoIpi">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (item of codigosEnquadramentoIpi; track item.id) {
                    <mat-option [value]="item.codigo">{{ item.codigo }} – {{ item.descricao }}</mat-option>
                    }
                </mat-select>
                @if (form.get('codigoEnquadramentoIpi')?.hasError('required') && form.get('codigoEnquadramentoIpi')?.touched) {
                <mat-error>Código de enquadramento é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- Tributação (ad valorem / ad rem) -->
        @if (algumAtivo(['pIPI', 'vUnid'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>calculate</mat-icon>
                    <span>Tributação</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('pIPI')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota IPI (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pIpi">
                            @if (form.get('pIpi')?.hasError('required') && form.get('pIpi')?.touched) {
                            <mat-error>Informe a alíquota ou o valor por unidade.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('vUnid')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Valor por unidade</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="vUnid">
                            @if (form.get('vUnid')?.hasError('required') && form.get('vUnid')?.touched) {
                            <mat-error>Informe a alíquota ou o valor por unidade.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

    </div>
</div>
</div>
